//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  children?: ReactNode;
}

export const NavDropdown = ({ children }: Props) => {
  return (
    <DropdownContainer>
      <DropdownColumn>{children}</DropdownColumn>
    </DropdownContainer>
  );
};

const DropdownContainer = styled.div`
  min-width: 120px;
  max-width: 200px;
`;

const DropdownColumn = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: calc(${theme.spacings[1]} * 3);
  `,
);
